$(document).ready(function() {	 
  var User_Id = $("#instafeed").data("user_id");
  var Access_Token = $("#instafeed").data("access_token");
  var limit = $("#instafeed").data("limit");


var userFeed = new Instafeed({
    get: 'user',
    userId: User_Id,
    accessToken: Access_Token,
    limit: limit,
    resolution: 'low_resolution',
     template: '<div class="insta-imges"><a href="{{link}}" target="_blank"><ul class="insta_item_overlay"><li><span><i class="icon-heart"></i></span> {{likes}}</li><li><span><i class="icon-comment"></i></span> {{comments}}</li></ul><div><img src="{{image}}"></div></a></div>'
  });

  userFeed.run();
});  